/**
 * Plain-text marker inserted into prefilled-email bodies, used to detect the
 * "please keep this line" footer paragraph when re-ordering / inserting
 * content into an outgoing email (see `MailForm.tsx`, `MailEditor.tsx`).
 *
 * NOTE: an HTML-entity-escaped variant of (part of) this string is matched by
 * a separate regex in `MailForm.tsx` (`deleteExtraTags`) — that regex is
 * intentionally left untouched, it targets different escaped text.
 */
export const EMAIL_FOOTER_MARKER = 'Tento řádek prosím v budoucí komunikaci zachovejte';
